import { render, staticRenderFns } from "./confidence.vue?vue&type=template&id=19bc1936&scoped=true&"
import script from "./confidence.vue?vue&type=script&lang=ts&"
export * from "./confidence.vue?vue&type=script&lang=ts&"
import style0 from "./confidence.vue?vue&type=style&index=0&id=19bc1936&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bc1936",
  null
  
)

export default component.exports